import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.damage.training');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-damage-training',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.damage.training/view.scss */
/* src/app/page.damage.training/view.scss: no such file or directory */`],
})
export class PageDamageTrainingComponent implements OnInit {
    public imageStats: any = {};
    public annotationStats: any = {};
    public history: any[] = [];
    public defaults: any = {};
    public modelInfo: any = {};
    public latestMetrics: any = null;
    public classRecallMetrics: any[] = [];

    // 학습 설정
    public config: any = { epochs: 50, batch_size: 4, learning_rate: 0.001 };

    // 학습 상태
    public isTraining: boolean = false;
    public trainingLogs: any[] = [];
    public currentEpoch: number = 0;
    public totalEpochs: number = 0;
    public currentLoss: number = 0;
    public currentAccuracy: number = 0;
    public trainingStatus: string = '';

    private abortController: AbortController | null = null;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadStats();
        await this.loadHistory();
        await this.service.render();
    }

    public async loadStats() {
        const { code, data } = await wiz.call('stats');
        if (code === 200) {
            this.imageStats = data.images;
            this.annotationStats = data.annotations;
            this.defaults = data.defaults || {};
            this.modelInfo = data.model || {};
            if (this.defaults.epochs) this.config.epochs = this.defaults.epochs;
            if (this.defaults.batch_size) this.config.batch_size = this.defaults.batch_size;
            if (this.defaults.learning_rate) this.config.learning_rate = this.defaults.learning_rate;
        }
    }

    public async loadHistory() {
        const { code, data } = await wiz.call('history');
        if (code === 200) {
            this.history = data.rows || [];
            this.updateLatestMetrics();
        }
        await this.service.render();
    }

    private updateLatestMetrics() {
        this.latestMetrics = this.history.find((model: any) =>
            model.status === 'completed' &&
            typeof model.macro_f1 === 'number' &&
            model.class_recall &&
            Object.keys(model.class_recall).length > 0
        ) || null;

        const recalls = this.latestMetrics?.class_recall || {};
        this.classRecallMetrics = Object.keys(recalls).map(className => ({
            class_name: className,
            recall: recalls[className]?.recall,
            support: recalls[className]?.support || 0
        }));
    }

    public async startTraining() {
        if (this.isTraining) return;

        this.isTraining = true;
        this.trainingLogs = [];
        this.currentEpoch = 0;
        this.trainingStatus = '학습 준비 중...';
        await this.service.render();

        this.abortController = new AbortController();

        try {
            const formData = new FormData();
            formData.append('epochs', String(this.config.epochs));
            formData.append('batch_size', String(this.config.batch_size));
            formData.append('learning_rate', String(this.config.learning_rate));

            const response = await fetch(`/wiz/api/page.damage.training/train`, {
                method: 'POST',
                body: formData,
                signal: this.abortController.signal
            });

            const reader = response.body!.getReader();
            const decoder = new TextDecoder();
            let buffer = '';

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;
                buffer += decoder.decode(value, { stream: true });
                const lines = buffer.split('\n\n');
                buffer = lines.pop() || '';

                for (const line of lines) {
                    if (line.startsWith('data: ')) {
                        try {
                            const event = JSON.parse(line.slice(6));
                            await this.handleTrainingEvent(event);
                        } catch (e) { }
                    }
                }
            }
        } catch (e: any) {
            if (e.name !== 'AbortError') {
                this.trainingStatus = `오류: ${e.message}`;
            }
        }

        this.isTraining = false;
        await this.loadHistory();
        await this.service.render();
    }

    private async handleTrainingEvent(event: any) {
        this.trainingLogs.push(event);

        switch (event.type) {
            case 'status':
            case 'info':
                this.trainingStatus = event.message;
                break;
            case 'training_start':
                this.totalEpochs = event.epochs;
                this.trainingStatus = `학습 시작 (${event.samples}개 샘플)`;
                break;
            case 'epoch':
                this.currentEpoch = event.epoch;
                this.totalEpochs = event.total_epochs;
                this.currentLoss = event.loss;
                this.currentAccuracy = event.accuracy;
                this.trainingStatus = `에포크 ${event.epoch}/${event.total_epochs}`;
                break;
            case 'complete':
                const macroF1 = typeof event.macro_f1 === 'number'
                    ? `, Macro F1: ${(event.macro_f1 * 100).toFixed(1)}%`
                    : '';
                this.trainingStatus = `학습 완료! Loss: ${event.final_loss}, Accuracy: ${(event.final_accuracy * 100).toFixed(1)}%${macroF1}`;
                break;
            case 'error':
                this.trainingStatus = `오류: ${event.message}`;
                break;
        }
        await this.service.render();
    }

    public stopTraining() {
        if (this.abortController) {
            this.abortController.abort();
            this.trainingStatus = '학습 중단됨';
            this.isTraining = false;
        }
    }

    public async deleteModel(id: string) {
        const res = await this.service.modal.show({
            title: '모델 삭제',
            message: '이 모델을 삭제하시겠습니까?',
            action: '삭제',
            status: 'error',
            actionBtn: 'error'
        });
        if (!res) return;
        await wiz.call('delete_model', { id });
        await this.loadHistory();
    }

    public exporting: boolean = false;

    public async exportOnnx(id: string) {
        if (this.exporting) return;
        this.exporting = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('export_onnx', { id });
            if (code === 200) {
                const sizeInfo = data.data?.size ? `\n크기: ${(data.data.size / 1024 / 1024).toFixed(1)}MB` : '';
                await this.service.modal.show({
                    title: 'ONNX 변환 완료',
                    message: `모델이 ONNX 형식으로 변환되었습니다.${sizeInfo}`,
                    action: '확인',
                    status: 'success',
                    cancel: false
                });
            } else {
                await this.service.modal.show({
                    title: 'ONNX 변환 실패',
                    message: data?.message || 'ONNX 변환 중 오류가 발생했습니다.',
                    action: '확인',
                    status: 'error'
                });
            }
        } catch (e) {
            await this.service.modal.show({
                title: 'ONNX 변환 실패',
                message: '서버와 통신 중 오류가 발생했습니다.',
                action: '확인',
                status: 'error'
            });
        } finally {
            this.exporting = false;
            await this.service.render();
        }
    }

    public downloadModel(id: string) {
        window.open(`/wiz/api/page.damage.training/download_model?id=${id}`, '_blank');
    }

    public progressPercent(): number {
        if (this.totalEpochs === 0) return 0;
        return Math.round((this.currentEpoch / this.totalEpochs) * 100);
    }

    public getClassList(): string[] {
        return Object.keys(this.annotationStats).filter(k => k !== 'total');
    }
}

export default PageDamageTrainingComponent;